import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import s from './MediumSophisticatedTooltipHeading.scss';
const MediumSophisticatedTooltipHeading = (_param)=>{
    var { children, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("span", _object_spread({
        className: c(s['root'], className)
    }, rest), children);
};
MediumSophisticatedTooltipHeading.displayName = 'MediumSophisticatedTooltipHeading';
export default MediumSophisticatedTooltipHeading;
